import Accordion from 'accordion-js';

class FooterAccordion {
  constructor() {
    this.footerItems = document.querySelectorAll('.footer__item--links');

    if (!this.footerItems) {
      return;
    }

    this.initAccordions();
  }

  initAccordions() {
    const mq = window.matchMedia('(max-width: 640px)');
    if (!mq.matches) {
      return;
    }

    const accordionContainer = document.querySelector('.footer__item-list');

    new Accordion(accordionContainer, {
      elementClass: 'footer__item--links',
      triggerClass: 'footer__item-title-wrapper',
      panelClass: 'footer__item-content',
      beforeOpen: (currentElement) => {
        currentElement.querySelector('.footer__item-icon').classList.add('is-active');
      },
      beforeClose: (currentElement) => {
        currentElement.querySelector('.footer__item-icon').classList.remove('is-active');
      },
    });
  }
}

export default FooterAccordion;
